import invariant from 'invariant';
import isDOMInstance from './isDOMInstance';

export default function ensureDOMInstance(node, type) {
  invariant(
    isDOMInstance(node, type),
    `An instance of ${type.name} is required, but received ${node}`,
  );
}
